import { render, staticRenderFns } from "./AddIntegration.vue?vue&type=template&id=50254a00&scoped=true&"
import script from "./AddIntegration.vue?vue&type=script&lang=js&"
export * from "./AddIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50254a00",
  null
  
)

export default component.exports